module.exports = __webpack_public_path__ + "img/crumbs.662abc27.gif";